<template>
	<v-dialog
		v-model="exibirModalProcessoDigital"
		persistent
		fullscreen
		scrollable
		transition="dialog-bottom-transition"
	>
		<v-card>
			<v-card-title class="pa-0">
				<v-row class="pa-0 ma-0 white--text primary">
					<v-col cols="12" sm="6" md="3" class="d-flex flex-row align-center justify-start">
						<v-btn @click="voltar" text dark>
							<span>
								<v-icon>mdi-arrow-left</v-icon>
								Voltar</span
							>
						</v-btn>
					</v-col>
				</v-row>
			</v-card-title>
			<v-card-text class="pa-0">
				<iframe class="arp-iframe" :src="url"></iframe>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	name: 'modal-visualizar-processo-digital',
	props: {
		url: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			exibirModalProcessoDigital: true,
		}
	},
	methods: {
		voltar() {
			this.$router.go(-1)
		},
	},
}
</script>
